import { createAnimations } from "@tamagui/animations-css";
const animations = createAnimations({
  easeInFast: "ease-in 0.2s",
  textInput: "ease-out 0.2s"
});
export { animations };
//# sourceMappingURL=animations.mjs.map
